import script from "./RAAIGoalsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RAAIGoalsPage.vue?vue&type=script&setup=true&lang=js"

import "./RAAIGoalsPage.vue?vue&type=style&index=0&id=62e96ea1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62e96ea1"]])

export default __exports__